<template>
  <div>
    <div class="float-to-left breadcrumb-section m__b--25">
      <h3>
        {{ $route.name.toUpperCase() }}
      </h3>
      <b-breadcrumb>
        <b-breadcrumb-item
          v-for="(item, index) in items"
          :to="item.to"
          :key="index"
          :active="item.active"
        >
          <span v-if="item.text === 'Home'">
            <i class="fa fa-home"></i>
          </span>
          <span v-else>
            {{ item.text }}
          </span>
        </b-breadcrumb-item>
      </b-breadcrumb>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data() {
    return {
      items: []
    };
  },
  watch: {
    $route() {
      this.generatePath();
    }
  },
  methods: {
    generatePath() {
      const parameter = this.$route.path.split('/');
      parameter.splice(0, 1);

      if (this.$route.path.includes('edit')) {
        parameter.splice(parameter.length - 1, 1);
      }

      this.items = parameter.map((data, index) => {
        let to = '';
        for (let i = 0; i <= index; i++) {
          to = to + ('/' + parameter[i]);
        }
        return {
          text: data.charAt(0).toUpperCase() + data.substr(1).toLowerCase(),
          active: Number(index) === Number(parameter.length - 1),
          to
        };
      });
    }
  },
  created() {
    this.generatePath();
  }
};
</script>

<style lang="scss">
.breadcrumb-section {
  a {
    color: #0095e9;
  }
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 37px;
  }
  .breadcrumb {
    padding-top: 7px;
    padding-left: 30px;
    background: unset;
  }
}
</style>
